// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

const initialState = fromJS({
  heading: null,
  isOpen: false,
  pathValidations: {},
})

export default initialState
